import { t } from "@/i18n-js/instance";
import { Icon } from "@circle-react-shared/Icon";
import { Button } from "@circle-react-shared/uikit/Button";
import { Typography } from "@circle-react-shared/uikit/Typography";
import { usePlansModal } from "../../shared/PlansModal";
import { useTrialBanner } from "./useTrialBanner";

export const TrialBanner = () => {
  const {
    trialEndDateMonthAndDayFormatted,
    expiringInTimer,
    trackTrialBannerClick,
  } = useTrialBanner();
  const plansModal = usePlansModal();

  const handleOnClick = () => {
    trackTrialBannerClick();
    void plansModal.show();
  };

  return (
    <div>
      <div className="text-darkest flex items-center gap-2">
        <Icon type="16-clock" size={16} />
        <Typography.BodySm weight="font-semibold" size="text-base">
          {t("trial_banner.upgrade_to_prevent", {
            formatted_date: trialEndDateMonthAndDayFormatted,
          })}
        </Typography.BodySm>
        {expiringInTimer && (
          <Typography.BodySm weight="font-normal" size="text-base">
            {t("trial_banner.expiring_in", {
              expiring_in_timer: expiringInTimer,
            })}
          </Typography.BodySm>
        )}

        <Button
          className="ml-1 text-base font-semibold"
          variant="circle"
          onClick={handleOnClick}
        >
          {t("trial_banner.cta")}
        </Button>
      </div>
    </div>
  );
};
